document.addEventListener('DOMContentLoaded', function() {
  // Cards that open modals
  const cards = document.querySelectorAll('[data-open-operative]');
  // Modals
  const modals = document.querySelectorAll('[data-operative-modal]');

  // Open modal on card click
  cards.forEach(card => {
    card.addEventListener('click', () => {
      const slug = card.getAttribute('data-open-operative');
      if (!slug) return;

      const modal = document.querySelector('[data-operative-modal="' + slug + '"]');
      if (!modal) return;

      modal.classList.add('ns-modal--open');
    });
  });

  // Close modals via overlay or X
  modals.forEach(modal => {
    const overlay = modal.querySelector('.ns-modal__overlay');
    const closeBtn = modal.querySelector('[data-close-operative]');

    function closeModal() {
      modal.classList.remove('ns-modal--open');
    }

    if (overlay) {
      overlay.addEventListener('click', closeModal);
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }
  });
});
